<template>
  <div>
    <v-dialog v-model="show" persistent max-width="380" eager>
      <v-card>
        <v-card-title class="justify-space-between">
          {{
            businessProfile.lastFour != undefined &&
            businessProfile.lastFour != ""
              ? "Update Payment Method"
              : "Add Payment Method"
          }}
          <v-btn fab text small @click="$emit('close')"
            ><v-icon class="text-right text--secondary">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <div
            class="mt-4 py-5 px-2"
            style="border: 1px solid #9e9e9e; border-radius: 8px"
          >
            <div ref="cardElement"></div>
          </div>
          <div class="text-caption error--text">
            {{ cardError }}
          </div>
          <v-row class="pb-0">
            <v-col class="pt-5 pb-0">
              <v-btn
                large
                elevation="0"
                color="primary"
                block
                @click="addNewPaymentMethod"
              >
                Update
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <LoadingDialog :show="loadingDialog" :title="loadingMessage" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoadingDialog from "@/components/LoadingDialog";
import {getHttpsCallable} from "@/shared/firebase_utils";

let stripe = Stripe(
  process.env.NODE_ENV == "production"
    ? "pk_live_51H57KKAb8fzN3Ilf9WjqI74BNpQmDCLJ5BdPu1XwMVIxjPdpJ21ZWKAIC0c0IOWkiHMcQ8XcWk9222zodr65ujKm00PucB5bqX"
    : "pk_test_51H57KKAb8fzN3IlflYhq2h05V8HKROSO5ZstUVOsHy9X3kmwfUL2x6z52yc67CYdALFdHbItBtiHwcMdKigqnhs800oWdLxtrs"
);
let elements = stripe.elements();
let cardElement = elements.create("card");

export default {
  props: { show: { type: Boolean, default: false } },
  computed: {
    ...mapGetters(["businessProfile"]),
  },
  components: {
    LoadingDialog,
  },
  mounted() {
    cardElement.mount(this.$refs.cardElement);
    cardElement.on("change", (event) => {
      this.showCardError(event);
    });
  },
  data() {
    return {
      cardError: "",
      loadingDialog: false,
      loadingMessage: "",
    };
  },
  // watch: {
  //   show: function (newValue, oldValue) {
  //     if (!newValue) {
  //       console.log("unmounting element...");
  //       //newValue is false
  //       cardElement.unmount();
  //     }
  //   },
  // },
  methods: {
    ...mapActions(["updateBusinessProfileDetails", "showSnackbar"]),

    addNewPaymentMethod() {
      this.loadingMessage = "Saving your new payment details...";
      this.loadingDialog = true;
      stripe
        .createPaymentMethod({
          type: "card",
          card: cardElement,
        })
        .then((result) => {
          if (result.error) {
            this.cardError = error;
            this.loadingDialog = false;
          } else {
            this.updatePaymentDetails(result.paymentMethod);
          }
        })
        .catch(() => {
          this.loadingDialog = false;
        });
    },
    async updatePaymentDetails(paymentMethod) {
      //Call a cloud function to attach the payment method to the stripe customer
      try {
        const updatePaymentDetails = getHttpsCallable("updatePaymentDetails");
        let response = await updatePaymentDetails({
          stripeCustomerId: this.businessProfile.stripeCustomerId,
          paymentMethodId: paymentMethod.id,
        });
        if (response.data.error != undefined) {
          this.cardError = response.data.error.message;
          this.loadingDialog = false;
        } else {
          //Done
          if (response.data.successfully) {
            //Update the Business Profile with the new card details
            await this.updateBusinessProfileDetails({
              lastFour: paymentMethod.card.last4,
              paymentMethod: paymentMethod.card.brand,
              paymentMethodExp:
                paymentMethod.card.exp_month +
                "/" +
                paymentMethod.card.exp_year,
            });
            this.loadingDialog = false;
            this.$emit("close");
          }
        }
      } catch (error) {
        this.cardError = error;
        this.loadingDialog = false;
      }
    },
    showCardError(event) {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = "";
      }
    },
  },
};
</script>

<style>
</style>